import React, { useState } from 'react';
import { Card, Row, Col, Form, Input, Button, Switch } from 'antd';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';

const PersonalInfo = () => {

    return <>Prerr</>
}

export default PersonalInfo;
